
import { mapGetters } from 'vuex'
import MixinMusicPlayer from '@/mixins/MixinMusicPlayer'
import MixinMusic from '@/mixins/MixinMusic'
import AppSlider from '~/components/AppSlider'
import MusicPlayerTimeline from '~/components/jukebox/MusicPlayerTimeline'

export default {
  name: 'MusicPlayer',
  components: { AppSlider, MusicPlayerTimeline },
  mixins: [MixinMusicPlayer, MixinMusic],
  data () {
    return {
      currentDate: new Date()
    }
  },
  computed: {
    ...mapGetters({
      isSidebarOpen: 'sidebar/isOpen',
      isSidebarExpanded: 'sidebar/isExpandedNavigation'
    }),
    repeatClass () {
      if (this.$store.state.jukebox.repeat === 'single') {
        return 'text-secondary fa-repeat-1'
      }

      if (this.$store.state.jukebox.repeat === 'all') {
        return 'text-secondary fa-repeat'
      }

      return 'fa-repeat'
    }
  },
  mounted () {
    document.body.classList.add('has-player')
  },
  destroyed () {
    document.body.classList.remove('has-player')
  },
  methods: {
    updateVolume (newValue) {
      this.volume = newValue / 100
      this.isMuted = newValue === 0
    },
    close () {
      this.$store.dispatch('jukebox/getInstance')
        .then((jukebox) => {
          if (jukebox.isPlaying()) {
            jukebox.pause()
          }

          this.$store.commit('jukebox/SET_ACTIVE', false)
        })
    },
    toggleShuffle () {
      if (!this.playerInitialized) {
        return
      }

      this.$store
        .dispatch('jukebox/getInstance')
        .then(jukebox => jukebox.shuffle())
        .then(({ data }) => {
          this.$store.commit('jukebox/SET_SHUFFLE', data.context.shuffle)
        })
    },
    toggleRepeat () {
      if (!this.playerInitialized) {
        return
      }

      this.$store
        .dispatch('jukebox/getInstance')
        .then(jukebox => jukebox.repeat())
        .then(({ data }) => {
          this.$store.commit('jukebox/SET_REPEAT', data.context.repeat)
        })
    }
  }
}
